// @ts-nocheck
const HALF_COLORING = "1/2";
const QUARTER_COLORING = "1/4";
const ONE_EIGHT_COLORING = "1/8";

const HALF_COLORING_CONDITIONS = {
    0.5: "1-2",
    1.0: "2-2",
};
const QUARTER_COLORING_CONDITIONS = {
    0.25: "1-4",
    0.5: "2-4",
    0.75: "3-4",
    1.0: "4-4",
};
const ONE_EIGHT_COLORING_CONDITIONS = {
    0.125: "1-8",
    0.25: "2-8",
    0.375: "3-8",
    0.5: "4-8",
    0.625: "5-8",
    0.75: "6-8",
    0.875: "7-8",
    1.0: "8-8",
};

function calculatePosition(rows, index, conditions) {
    const position = (index + 1) / rows.length;

    let result = "";
    Object.keys(conditions)
        .sort(function (a, b) {
            return a - b;
        })
        .forEach(function (arrayPart) {
            arrayPart = parseFloat(arrayPart);
            if (!result && position <= arrayPart) {
                result = conditions[arrayPart];
            }
        });
    return result;
}

module.exports = function (rowColoringType, rows, index) {
    if (rowColoringType === HALF_COLORING) {
        return calculatePosition(rows, index, HALF_COLORING_CONDITIONS);
    }
    if (rowColoringType === QUARTER_COLORING) {
        return calculatePosition(rows, index, QUARTER_COLORING_CONDITIONS);
    }
    if (rowColoringType === ONE_EIGHT_COLORING) {
        return calculatePosition(rows, index, ONE_EIGHT_COLORING_CONDITIONS);
    }
    return null;
};
